var Handlebars = require("../../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_14.16.0/lib/node_modules/@core/macys-cli/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"footer-redesign-ads-row\">\n</div>\n"
    + ((stack1 = container.invokePartial(require("./dataDrivenFooter.hbs"),depth0,{"name":"footer/dataDrivenFooter","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/Polaris/header-footer-wgl/polaris_deploy_header-footer-wgl_deployable_pipeline/package/node_modules/@feature/footer/src/templates/partials/footer/responsive.hbs
// module id = 785
// module chunks = 22